<template>
<div>
	
	<SimpleForm
		:autofocus="!autofocus"
		:onSubmit="login"
		:fields="[
			{
				label : 'Email address',
				name : 'email',
				type : 'email',
				autocomplete : 'username',
				required : true,
			},
			{
				label : 'Password',
				name : 'password',
				type : 'password',
				autocomplete : 'current-password',
				required : true,
			},
		]"
		:model="creds"
	/>

</div>
</template>

<script>

	import { mapGetters } from 'vuex'

	export default {

		props : ['autofocus','invite'],

		data() {
			return {
				creds : {
					email: (this.invite||{}).email || '',
					password: '',
				},
				...mapGetters('auth',{
					'logged_in' : 'is_logged_in',
				}),
			};
		},

		methods: {
			login(values) {
				var self = this;

				let creds = values;

				if(this.invite){
					creds.invite_id = this.invite.id;
				}

				return this.$store.dispatch('auth/login',creds)
					.then(function(){
						if(self.logged_in){

							var name = self.$store.state.auth.user.first_name;
							var greetings = [
								'Login success!',
								'Hi there '+name+'!',
								'Hello '+name+'!',
								'Welcome back '+name+'!',
							];

							var greeting = greetings[Math.floor(Math.random()*greetings.length)];

							Event.$emit('success',greeting);
							self.$router.push( (self.$route.query||{}).redirect || '/' );
						}
					})
					.catch(function(e){
						// console.log([a,b])
						alert(e.message);
					});

			}
		}
	}

</script>